
import React from 'react';

const CompanyJobsTab: React.FC = () => {
  return (
    <div>
      <p className="text-gray-600 mb-6">Manage your company's job listings here.</p>
      <div className="bg-[#F2FCE2] border border-green-200 rounded-md p-4">
        <p className="text-green-700">
          Please follow this link to <a href="https://www.greenflags.com.au" target="_blank" rel="noopener noreferrer" className="text-green-700 underline hover:text-green-800">GreenFlags</a> to set up and connect your account
        </p>
      </div>
    </div>
  );
};

export default CompanyJobsTab;
